import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

function CreateSubCategory() {
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_APIURL;

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [formdata, setFormdata] = useState({
    name: "",
    category: "", // Corrected field name to match backend
  });

  // Fetch categories from API to populate the dropdown
  useEffect(() => {
    const fetchCategories = async () => {
      if (!token) {
        toast.error("Authentication token not found.");
        return;
      }
      try {
        const response = await axios.get(`${baseUrl}api/catagorylist`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data && response.data.catagories) {
          setCategories(response.data.catagories);
        } else {
          toast.error("Failed to fetch categories");
        }
      } catch (error) {
        toast.error(
          "Something went wrong while fetching categories: " +
            (error.response?.data?.message || error.message)
        );
      }
    };
    fetchCategories();
  }, [token, baseUrl]);

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formdata.name || !formdata.category) { // Corrected validation check
      toast.warn("Please fill out all fields.");
      return;
    }
    setLoading(true);

    try {
      const response = await axios.post(
        `${baseUrl}api/sub-category/create`,
        formdata, // formdata now has { name: '...', category: '...' }
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Sub-category added successfully!");
     // Redirect on success
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to add sub-category"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Sub-Categories</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/sub-category-list">Sub-Category List</Link>
              </li>
              <li className="breadcrumb-item active">Add Sub-Category</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Add New Sub-Category</h5>
            <form className="row g-3 pt-3" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <div className="form-floating">
                  <select
                    className="form-select"
                    id="category"
                    name="category" // Corrected name attribute
                    value={formdata.category} // Corrected value binding
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Parent Category</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.catagoryname}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="category">Parent Category</label>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Sub-Category Name"
                    name="name"
                    value={formdata.name}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Sub-Category Name</label>
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Sub-Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default CreateSubCategory;
